import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  width: 100%;\n\n  .text {\n    @media (max-width: 750px) {\n      font-size: ",
        ";\n      line-height: ",
        ";\n    }\n    color: var(--text-color-secondary);\n  }\n\n  .purple:before {\n    display: inline-block;\n    position: relative;\n    content: ' ';\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n    bottom: 1px;\n    background-color: ",
        ";\n  }\n\n  .purple {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createLearnMoreButton } from "@purple-dot/web-components/learn-more/learn-more-modal";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useTranslation } from "../use-translation";
var Branding = styled(function(param) {
    var className = param.className, useExtendedDeliveryLanguage = param.useExtendedDeliveryLanguage, storeId = param.storeId;
    var t = useTranslation().t;
    var textContainer = useRef(null);
    useEffect(function() {
        var ref;
        var learnMoreButton = createLearnMoreButton({
            HOST: getOrigin(),
            hideBackToProduct: true,
            useExtendedDeliveryLanguage: useExtendedDeliveryLanguage,
            storeIdentifier: {
                storeId: storeId
            }
        });
        learnMoreButton.setAttribute("data-testid", "learn-more-button");
        learnMoreButton.setAttribute("class", "text");
        (ref = textContainer.current) === null || ref === void 0 ? void 0 : ref.appendChild(learnMoreButton);
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsxs("span", {
            className: "text",
            ref: textContainer,
            children: [
                useExtendedDeliveryLanguage ? t("translation:self-service.common.extended-delivery-protected-by") : t("translation:self-service.common.waitlist-protected-by"),
                " ",
                /*#__PURE__*/ _jsx("span", {
                    className: "purple",
                    children: " Purple Dot"
                }),
                ".",
                " "
            ]
        })
    });
})(_templateObject(), function(param) {
    var forCheckout = param.forCheckout;
    return forCheckout ? "14px" : "auto";
}, function(param) {
    var forCheckout = param.forCheckout;
    return forCheckout ? "22px" : "auto";
}, function(param) {
    var theme = param.theme;
    return theme.pdLogo.color;
}, function(param) {
    var theme = param.theme;
    return theme.pdLogo.color;
});
function getOrigin() {
    return window.location.origin;
}
export default Branding;
